<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="开票申请编号" prop="ticketApplyCode">
          <el-input v-model="dataForm.ticketApplyCode" placeholder="开票申请编号"></el-input>
      </el-form-item>
          <el-form-item label="购买方名称" prop="buyerName">
          <el-input v-model="dataForm.buyerName" placeholder="购买方名称"></el-input>
      </el-form-item>
          <el-form-item label="统一社会信用编码" prop="taxCode">
          <el-input v-model="dataForm.taxCode" placeholder="统一社会信用编码"></el-input>
      </el-form-item>
          <el-form-item label="发票类型" prop="ticketType">
          <el-input v-model="dataForm.ticketType" placeholder="发票类型"></el-input>
      </el-form-item>
          <el-form-item label="含税金额（元）" prop="money">
          <el-input v-model="dataForm.money" placeholder="含税金额（元）"></el-input>
      </el-form-item>
          <el-form-item label="开票状态" prop="ticketStatus">
          <el-input v-model="dataForm.ticketStatus" placeholder="开票状态"></el-input>
      </el-form-item>
          <el-form-item label="开票主体名称" prop="ticketBody">
          <el-input v-model="dataForm.ticketBody" placeholder="开票主体名称"></el-input>
      </el-form-item>
          <el-form-item label="开票单号" prop="expressCode">
          <el-input v-model="dataForm.expressCode" placeholder="开票单号"></el-input>
      </el-form-item>
          <el-form-item label="申请时间" prop="applyDate">
          <el-input v-model="dataForm.applyDate" placeholder="申请时间"></el-input>
      </el-form-item>
          <el-form-item label="开票完成时间" prop="finishDate">
          <el-input v-model="dataForm.finishDate" placeholder="开票完成时间"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        ticketApplyCode: '',
        buyerName: '',
        taxCode: '',
        ticketType: '',
        money: '',
        ticketStatus: '',
        ticketBody: '',
        expressCode: '',
        applyDate: '',
        finishDate: '',
        creator: '',
        createDate: '',
        updater: '',
        updateDate: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        ticketApplyCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        buyerName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        taxCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        ticketType: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        money: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        ticketStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        ticketBody: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        expressCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        applyDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        finishDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/plat/platticketrecord/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/plat/platticketrecord/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
